var _circle, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDashboardDrafts = function SvgDashboardDrafts(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "url(#dashboard-drafts_svg__a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M10.71 30.58 20.129 40C31.097 39.935 39.935 31.097 40 20.129l-9.42-9.42z",
    clipRule: "evenodd",
    opacity: 0.15
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFCF2",
    fillRule: "evenodd",
    d: "M29.677 10.323H11.613c-.71 0-1.29.58-1.29 1.29v18.064c0 .71.58 1.29 1.29 1.29H23.87l7.097-7.096V11.613c0-.71-.58-1.29-1.29-1.29",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#D4DAE1",
    fillRule: "evenodd",
    d: "M23.871 23.871v7.097l7.097-7.097zm-9.677 2.58h7.096v-1.29h-7.096zm12.258-5.16H14.193v1.29h12.259zm0-3.872H14.193v1.29h12.259zm-2.581-3.87h-9.677v1.29h9.677z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "dashboard-drafts_svg__a",
    x1: 0,
    x2: 42.236,
    y1: 40,
    y2: 2.519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009AC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.607,
    stopColor: "#00CCBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60F3AB"
  })))));
};
export { SvgDashboardDrafts as ReactComponent };
export default __webpack_public_path__ + "fonts/dashboard-drafts-09c3e188dc9a59670215ac2cd08231bb.svg";